import { Record } from 'immutable';

const BankAccountsPreviewRecord = Record({
  balance: 0,
});

export default class BankAccountsPreview extends BankAccountsPreviewRecord {
  static deserialize(jsonObject) {
    if (
      typeof jsonObject === 'undefined' ||
      jsonObject === null ||
      (typeof jsonObject === 'object' && !Object.keys(jsonObject).length)
    ) {
      return undefined;
    }

    return new BankAccountsPreview(jsonObject);
  }
}
